import moment from 'moment';

export function toggleInOut(value) {
    if (value === 1) {
        return 'IN';
    } else {
        return 'OUT';
    }
}

export function enableToggle(value) {
    if (value === 0) {
        return 'Y';
    } else {
        return 'N';
    }                 
}

export function yesNoToggle(value) {
    if (value === 0) {
        return 'N';
    } else {
        return 'Y';
    }                 
}

export function checkNullVal(value) {
    if (!value) {
        return '';
    } else  {
        return value;
    }
}

export function formatUXDateTime(value) {
    if (value) {
        return moment.unix(value).format('YYYY-MM-DD hh:mm:ss A');
    }
}

export function formatUX24DateTime(value) {
    if (value) {
        return moment.unix(value).format('YYYY-MM-DD HH:mm:ss');
    }
}

export function formatUXDate(value) {
    if (value) {
        return moment.unix(value).format('YYYY-MM-DD');
    }
}

export function formatUXTime(value) {
    if (value) {
        return moment.unix(value).format('hh:mm:ss a');
    }
}

export function formatUX24Time(value) {
    if (value) {
        return moment.unix(value).format('HH:mm:ss');
    }
}




// WEBPACK FOOTER //
// ./src/components/common/toggle.js